// سياسة كلمة المرور الموحّدة: 8 أحرف على الأقل + حرف + رقم + رمز (إلزامية في كل التطبيق).
export const MIN_PASSWORD = 8;

export const passwordRules = (value = "") => [
  { key: "min", ok: value.length >= MIN_PASSWORD },
  { key: "letter", ok: /[A-Za-z]/.test(value) },
  { key: "number", ok: /\d/.test(value) },
  { key: "symbol", ok: /[^A-Za-z0-9]/.test(value) },
];

export const isStrongPassword = (value = "") => passwordRules(value).every((r) => r.ok);

// 0-4: عدد الشروط المحققة، ودرجة «قوية جداً» تتطلب 12 حرفاً أو أكثر.
export const scorePassword = (value = "") => {
  if (!value) return 0;
  const met = passwordRules(value).filter((r) => r.ok).length;
  if (met < 4) return met;
  return value.length >= 12 ? 4 : 3;
};
